import React from 'react';
import { getWebAbsPath } from '../../../../util/path';
import style from '../../NewPatientSummary/NewPatientSummary.module.css';
import { renderToothMarkers } from '../../NewPatientUtill';
import { useLang } from '../../../../util/lang';

const TeethDisplaySummary = ({ teeth, toothSelection = [], imgSrc = '' }) => {
    const getLang = useLang();
    const src = imgSrc || '/img/prescriptionNotes/checkSuccess.png';
    if (!teeth) return null;
    return (
        <div className={style.toothImages}>
            <div>{getLang('@NewPatient.prescriptionNotes.onlayQuestion')}</div>
            <div
                style={{
                    width: 800,
                    height: 200,
                    marginTop: 10,
                    position: 'relative',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
                }}
            >
                {renderToothMarkers(toothSelection, teeth, src)}
            </div>
        </div>
    );
};

export default TeethDisplaySummary;
